<template>
  <div>
    <h1>Listagem de regiões prazo entrega</h1>
    <div>
      <b-table hover :items="regioesPrazoEntrega" :fields="fields">  

      <template v-slot:cell(id)="data">
        <!-- `data.value` is the value after formatted by the Formatter -->
        <!-- <a :href="`#${data.value.replace(/[^a-z]+/i,'-').toLowerCase()}`">{{ data.value }}</a> -->
        <router-link :to="'/rotaPrazoEntrega/edit/' + data.value">{{ data.value }}</router-link>
      </template>      

      </b-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "List",
  data: function() {
    return {
      fields: [
        {
          key: "id",
          sortable: true
        },
        {
          key: "paisId",
          sortable: true
        },
        {
          key: "regiaoPaisId",
          sortable: true
        },
        {
          key: "estadoId",
          sortable: true
        },
        {
          key: "regiaoEstadoId",
          sortable: true
        },
        {
          key: "municipioId",
          sortable: true
        },
        {
          key: "cep",
          sortable: true
        },
        {
          key: "prazo",
          sortable: true
        },
        {
          key: "diasPosColeta",
          sortable: true
        },
      ],
      regioesPrazoEntrega: []
    };
  },
  created: function() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.$api.get("/rotaPrazoEntrega/")
        .then((response) => {
          this.regioesPrazoEntrega = response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            // this.tableIsBusy = false;
            // this.tableRowCount = 0;
             this.regioesPrazoEntrega = [];
            // return [];
          }
        });
    }
  }
};
</script>

